import {defaultStringifySearch} from '@tanstack/react-router';
import {cloneDeep} from 'lodash-es';

export function prepareSearchParams(
  _obj: Record<string, unknown>,
  shouldRemovePagination = false
): string | undefined {
  const obj = cloneDeep(_obj);
  if (shouldRemovePagination) {
    delete obj.top;
    delete obj.skip;
  } else {
    obj.count = true;
  }

  const truthy = removeNullishValues(obj);
  if (!truthy) return undefined;

  Object.keys(truthy).forEach((key) => {
    const property = truthy[key];
    if (Array.isArray(property)) {
      truthy[key] = property.join(',');
    }
  });

  const stringified = defaultStringifySearch(truthy);
  return stringified;
}

// https://medium.com/mizyind-singularity/remove-blank-attributes-from-an-object-in-typescript-with-type-safe-ad4fd78a061c
type Valuable<T> = {
  [K in keyof T as T[K] extends null | undefined ? never : K]: T[K];
};
function removeNullishValues<T extends object, V = Valuable<T>>(
  obj: T
): V | undefined {
  const entries = Object.entries(obj).filter(
    ([, v]) =>
      !(
        (typeof v === 'string' && !v.length) ||
        v === null ||
        typeof v === 'undefined'
      )
  );

  // when using for api query params, empty object appends ? to url
  if (!entries.length) return;

  return Object.fromEntries(entries) as V;
}
